import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/app/node_modules/.pnpm/next@15.2.4_@babel+core@7.24.9_@playwright+test@1.50.1_react-dom@19.1.0_react@19.1.0__react@19.1.0/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/app/src/app/globals.css");
;
import(/* webpackMode: "eager", webpackExports: ["CookieConsentProvider"] */ "/app/src/contexts/CookieConsentContext.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["CookieConsent"] */ "/app/src/ui/components/CookieConsent.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["GoogleAnalyticsWrapper"] */ "/app/src/ui/components/GoogleAnalyticsWrapper.tsx");
